import cms from './cms';

// ID 1 --> Vehículos (Marca, Modelo, Placa, Año, Color,Fecha marbete)
// ID 4 --> Motocicletas (Marca, Modelo, Placa, Año, Color, Fecha marbete)
// ID 2 --> Hogares (Pais, Dirección 1, Ciudad, Código Zip)

const IDS_ALLOWED = {
  1: [1, 2, 3, 4, 10, 22, 23],
  4: [1, 2, 3, 4, 10, 22, 23],
  2: [6, 7, 8, 9],
};

interface PropertyFromAPI {
  id: number;
  name: string;
  status: boolean;
  type: string | null;
  length: number | null;
  required: boolean | null;
  large: string | null;
  name_intl_eng: string | null;
  order_number: number | null;
  endpoint: string | null;
  parameters: string | null;
  file_order: number | null;
  createdAt: string;
  updatedAt: string;
  publishedAt: string;
}

/**
 * Function to get all properties by user id
 * @param id of type number
 * @returns Object
 */
export async function getPropertyTypeById(id: number) {
  try {
    const response = await cms.get(`product-types/${id}`);
    return { ...response.data.data.attributes, id: response.data.data.id };
  } catch (error) {
    console.error('Error getPropertyTypeById 🚨', error);
    throw error;
  }
}

export async function getUserProperties(typeId: number) {
  try {
    if (!IDS_ALLOWED[typeId as keyof typeof IDS_ALLOWED]) {
      throw new Error('Type ID not found');
    }
    const response = await cms.get(`/v2/properties`);

    const propertiesArray = response.data;

    // Filtrar solo las propiedades cuyos IDs están en IDS_ALLOWED
    const filteredProperties = propertiesArray.filter(
      (property: PropertyFromAPI) =>
        IDS_ALLOWED[typeId as keyof typeof IDS_ALLOWED].includes(property.id)
    );

    const transformedProperties = filteredProperties.map(
      (property: PropertyFromAPI) => ({
        id: property.id,
        attributes: {
          name: property.name,
          status: property.status,
          type: property.type,
          length: property.length,
          required: property.required,
          large: property.large,
          name_intl_eng: property.name_intl_eng,
          order_number: property.order_number,
          endpoint: property.endpoint,
          parameters: property.parameters,
          file_order: property.file_order,
        },
      })
    );

    return {
      id: typeId,
      name: 'Properties',
      enabled: true,
      propiedades: {
        data: transformedProperties,
      },
    };
  } catch (error) {
    console.error('Error getUserProperties 🚨', error);
    throw error;
  }
}
